exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editado-sample-img {\n  padding: 20px; }\n\n.editado-text {\n  padding: 10px;\n  font-size: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/editado-sheet-qa-modal/editado-sheet-qa-modal.component.scss
// module id = ../../../../../src/app/shared/modals/editado-sheet-qa-modal/editado-sheet-qa-modal.component.scss
// module chunks = main